const publicUrl = process.env.PUBLIC_URL || '';

export const lunchMenuPdf = `${publicUrl}/tagesangebote-november.pdf`;

const ZURICH_TIME_ZONE = 'Europe/Zurich';
const NEXT_LUNCH_PROMOTION_HOUR = 15;

export const lunchOffers = [
  {
    date: '2026-09-28',
    title: 'Kürbis-Auflauf',
    detail: 'serviert mit einem Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-09-29',
    title: 'Zucchetti-Halloumi-Spiesse',
    detail: 'mit Brötli und Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-09-30',
    title: 'Gemüsemuffins',
    detail: 'serviert mit kleinem Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-01',
    title: 'Kürbis-Spinat-Lasagne',
    detail: 'mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-02',
    title: 'Pilz-Heidelbeer-Risotto',
    detail: 'mit Gruyère',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-05',
    title: 'Teigwaren-Auflauf',
    detail: 'mit Käse und Spinat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-06',
    title: 'Gemüse-Taschen',
    detail: 'serviert mit Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-07',
    title: 'Kürbis-Risotto',
    detail: 'mit Gruyère',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-08',
    title: 'Älpler-Magronen',
    detail: 'mit Apfelmus',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-09',
    title: 'Spätzlipfanne',
    detail: 'mit Käse und Gemüse',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-12',
    title: 'Penne',
    detail: 'mit hausgemachtem Pesto',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-13',
    title: 'Ciabatta-Antipasti-Pizza',
    detail: 'mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-14',
    title: 'Pilz-Risotto',
    detail: 'mit Gruyère',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-15',
    title: 'Tomaten-Ricotta-Auflauf',
    detail: 'serviert mit Salat und Brot',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-16',
    title: 'Gemüse-Lasagne',
    detail: 'serviert mit kleinem Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-19',
    title: 'Zucchetti-Ricotta-Auflauf',
    detail: 'serviert mit Brot',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-20',
    title: 'Gemüsemuffins',
    detail: 'serviert mit kleinem Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-21',
    title: 'Älpler-Magronen',
    detail: 'mit Apfelmus',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-22',
    title: 'Zucchetti-Zitronen-Risotto',
    detail: 'mit Gruyère',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-23',
    title: 'Gemüse-Taschen',
    detail: 'serviert mit Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-26',
    title: 'Polenta-Pizza',
    detail: 'mit Gemüse, dazu ein Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-27',
    title: 'Toast-Williams',
    detail: 'mit Birne, Käse und Speck, dazu Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-28',
    title: 'Kürbis-Spinat-Lasagne',
    detail: 'mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-10-29',
    title: 'Spätzlipfanne',
    detail: 'mit Käse und Gemüse',
    price: 'CHF 17.50'
  },
  {
    date: '2026-10-30',
    title: 'Zucchetti-Risotto',
    detail: 'mit Gruyère',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-02',
    title: 'Ciabatta-Antipasti-Pizza',
    detail: 'mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-03',
    title: 'Gemüse-Taschen',
    detail: 'serviert mit Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-04',
    title: 'Spätzlipfanne',
    detail: 'mit Käse und Gemüse',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-05',
    title: 'Gemüseeintopf',
    detail: 'serviert mit Brot und Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-06',
    title: 'Älpler-Magronen',
    detail: 'mit Apfelmus',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-09',
    title: 'Teigwaren-Auflauf',
    detail: 'mit Käse und Spinat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-10',
    title: 'Polenta-Pizza',
    detail: 'mit Gemüse, dazu ein Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-11',
    title: 'Pilz-Risotto',
    detail: 'serviert mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-12',
    title: 'Kürbis-Spinat-Lasagne',
    detail: 'mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-13',
    title: 'Kartoffelgratin',
    detail: 'mit Gemüse, dazu ein Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-16',
    title: 'Strudel',
    detail: 'mit Gemüsefüllung, dazu ein Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-17',
    title: 'Penne',
    detail: 'mit hausgemachtem Pesto, dazu Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-18',
    title: 'Zucchetti-Ricotta-Auflauf',
    detail: 'serviert mit Salat und Brot',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-19',
    title: 'Gemüse-Lasagne',
    detail: 'serviert mit kleinem Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-20',
    title: 'Tomaten-Risotto',
    detail: 'serviert mit kleinem Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-23',
    title: 'Toast-Williams',
    detail: 'mit Birne, Käse und Speck, dazu Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-24',
    title: 'Spätzlipfanne',
    detail: 'mit Käse und Gemüse',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-25',
    title: 'Älpler-Magronen',
    detail: 'mit Apfelmus',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-26',
    title: 'Kürbis-Risotto',
    detail: 'serviert mit Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-11-27',
    title: 'Gemüse-Taschen',
    detail: 'serviert mit Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-11-30',
    title: 'Kartoffelgratin',
    detail: 'mit Gemüse, dazu ein Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-12-01',
    title: 'Gemüseeintopf',
    detail: 'serviert mit Brot und Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-12-02',
    title: 'Risotto mit Oliven',
    detail: 'dazu ein kleiner Salat',
    price: 'CHF 19.50'
  },
  {
    date: '2026-12-03',
    title: 'Spinat-Ricotta-Strudel',
    detail: 'dazu ein kleiner Salat',
    price: 'CHF 17.50'
  },
  {
    date: '2026-12-04',
    title: 'Teigwaren-Auflauf',
    detail: 'mit Käse und Spinat',
    price: 'CHF 17.50'
  }
];

function getDateParts(date = new Date()) {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: ZURICH_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
}

function getDateTimeParts(date = new Date()) {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: ZURICH_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date);
}

export function getZurichTodayIso(date = new Date()) {
  const parts = Object.fromEntries(getDateParts(date).map((part) => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function formatLunchDate(dateIso, options = {}) {
  return new Intl.DateTimeFormat('de-CH', {
    timeZone: ZURICH_TIME_ZONE,
    weekday: options.weekday ?? 'long',
    day: '2-digit',
    month: '2-digit'
  }).format(new Date(`${dateIso}T12:00:00Z`));
}

export function getLunchOfferForDate(dateIso = getZurichTodayIso()) {
  return lunchOffers.find((offer) => offer.date === dateIso) ?? null;
}

export function getUpcomingLunchOffers(dateIso = getZurichTodayIso(), limit) {
  const offers = lunchOffers.filter((offer) => offer.date >= dateIso);
  return typeof limit === 'number' ? offers.slice(0, limit) : offers;
}

function isAfterTodayPromotionCutoff(referenceDate) {
  const parts = Object.fromEntries(getDateTimeParts(referenceDate).map((part) => [part.type, part.value]));
  return Number(parts.hour) >= NEXT_LUNCH_PROMOTION_HOUR;
}

function getNextLunchOfferAfterDate(dateIso) {
  return lunchOffers.find((offer) => offer.date > dateIso) ?? null;
}

export function getFeaturedLunchOffer(referenceDate = new Date()) {
  const dateIso = typeof referenceDate === 'string'
    ? referenceDate
    : getZurichTodayIso(referenceDate);
  const todayOffer = getLunchOfferForDate(dateIso);

  if (todayOffer && (typeof referenceDate === 'string' || !isAfterTodayPromotionCutoff(referenceDate))) {
    return {
      label: 'Heute als Tagesgericht',
      offer: todayOffer,
      isToday: true
    };
  }

  const [upcomingOffer] = getUpcomingLunchOffers(dateIso, 1);
  const nextOffer = todayOffer
    ? getNextLunchOfferAfterDate(dateIso)
    : upcomingOffer;

  return {
    label: nextOffer ? 'Nächstes Tagesgericht' : 'Tagesgericht',
    offer: nextOffer ?? null,
    isToday: false
  };
}
